import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Scrollbars } from 'react-custom-scrollbars';

import { reduxForm, Field, FieldArray } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Button from 'components/common/Button';
import TextField from 'components/fields/TextField';

import hexToRgb from 'styles/hexToRgb';

import * as validate from 'utils/validate';

import TemplatesCreateEditFormFieldMenuChoices from './TemplatesCreateEditFormFieldMenuChoices';

const styles = theme => ({
  root: {
    width: 280,
  },
  header: {
    padding: '16px 16px 0',
  },
  body: {
    padding: '16px 16px 24px',
  },
  footer: {
    boxShadow: `0 2px 10px 0 rgba(${hexToRgb(theme.palette.secondary.A100)},0.14)`,
  },
  buttonSubmit: {
    minWidth: 0,
  },
  buttonCancel: {
    fontWeight: 400,
    textTransform: 'none',
    minWidth: 0,
    color: theme.palette.grey[700],
  },
});

const TemplatesCreateEditFormFieldMenu = ({
  submit,
  onCancel,
  variant,
  classes,
}) => {
  let title;
  let label = 'Question text';
  switch (variant) {
    case 'Textbox':
      title = 'Free Textbox';
      break;
    case 'MultiLine':
      title = 'Multi-line text box';
      break;
    case 'Radio':
      title = 'Radio Button';
      break;
    case 'Checkbox':
      title = 'Checkbox';
      break;
    case 'DropDown':
      title = 'Dropdown';
      break;
    case 'Date':
      title = 'Date';
      break;
    case 'Signature':
      title = 'Signature';
      label = 'Content';
      break;
    default:
      title = null;
  }
  return (
    <div className={classes.root}>
      {['Radio', 'Checkbox', 'DropDown'].indexOf(variant) !== -1 ? (
        <Scrollbars
          autoHeight
          autoHeightMin={0}
          autoHeightMax={298}
          thumbMinSize={30}
          universal
        >
          {title &&
            <div className={classes.header}>
              <Typography variant="subheading">
                {title}
              </Typography>
            </div>
          }
          <div className={classes.body}>
            <Grid
              container
              justify="space-between"
              alignItems="center"
              spacing={0}
              wrap="nowrap"
            >
              <Grid item xs={12}>
                <Field
                  id="Text"
                  name="Text"
                  label={label}
                  component={TextField}
                  {...variant === 'Textbox' ? { validate: [validate.required] } : {}}
                  fullWidth
                />
              </Grid>
            </Grid>
            <FieldArray
              name="Choices"
              component={TemplatesCreateEditFormFieldMenuChoices}
            />
          </div>
        </Scrollbars>
      ) : (
        <Fragment>
          {title &&
            <div className={classes.header}>
              <Typography variant="subheading">
                {title}
              </Typography>
            </div>
          }
          <div className={classes.body}>
            <Grid
              container
              justify="space-between"
              alignItems="center"
              spacing={0}
              wrap="nowrap"
            >
              <Grid item xs={12}>
                <Field
                  id="Text"
                  name="Text"
                  label={label}
                  component={TextField}
                  {...variant === 'Textbox' ? { validate: [validate.required] } : {}}
                  maxLength=""
                  multiline={variant === 'Textbox'}
                  fullWidth
                />
              </Grid>
            </Grid>
          </div>
        </Fragment>
      )}
      <div className={classes.footer}>
        <Grid
          container
          justify="space-between"
          alignItems="center"
          spacing={0}
          wrap="nowrap"
        >
          <Grid item>
            <Button
              className={classes.buttonCancel}
              color="inherit"
              onClick={onCancel}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button
              className={classes.buttonSubmit}
              color="primary"
              onClick={submit}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

TemplatesCreateEditFormFieldMenu.propTypes = {
  submit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  variant: PropTypes.oneOf([
    'Textbox',
    'MultiLine',
    'Radio',
    'Checkbox',
    'DropDown',
    'Date',
    'Signature',
  ]).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    footer: PropTypes.string.isRequired,
  }).isRequired,
};


export default reduxForm({
  onSubmit: values => values,
  enableReinitialize: true,
})(withStyles(styles)(TemplatesCreateEditFormFieldMenu));



// WEBPACK FOOTER //
// ./src/components/settings/TemplatesCreateEditForm/TemplatesCreateEditFormFieldMenu.js